// src/api/mockBackend.js

export async function fetchGameOfTheDay() {
  const res = await fetch('/api/game');
  if (!res.ok) throw new Error('Erro ao buscar o jogo do dia');
  return await res.json();
}

export async function checkAnswer(userAnswer) {
  const res = await fetch('/api/game', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ userAnswer })
  });
  if (!res.ok) throw new Error('Erro ao verificar resposta');
  return await res.json();
}

export async function fetchHint(type, letterIdx = null) {
  const params = new URLSearchParams({ type });
  if (type === 'letter' && letterIdx !== null) {
    params.append('letterIdx', letterIdx);
  }
  const res = await fetch(`/api/hint?${params.toString()}`);
  if (!res.ok) throw new Error('Erro ao buscar dica');
  return await res.json();
}
